exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".notes-history{\n    max-height:600px;\n    overflow: auto;\n    position:relative;\n    padding:0 15px;\n}\n.notes-history .item{\n    padding-bottom:15px;\n}\n.notes-history .item .date{\n    text-align:left;\n    font-size:10px;\n}\n.notes-history .item .author{\n    text-align: right;\n    font-size:10px;\n}\n.notes-history .item .author .name{\n    font-size:16px;\n    font-weight:bold;\n}\n.notes-history .item .author .role{\n    font-size:14px;\n}\n.notes-history .item .author .company{\n    font-size:10px;\n}\n.notes-history .item .message{\n    background-color: #f5f5f5;\n    padding:7px;\n    word-wrap: break-word;\n}\n.new-note textarea {\n    resize: vertical;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/client-notes/client-notes.component.css
// module id = 1208
// module chunks = 9